module.exports = __webpack_public_path__ + "media/assets/site_images/team/tiago-364a6c6e17a84939f7709e31a2692786.png";